import { useEffect } from 'react';
import { SSM0004_GROUP_PARAMETER_KEY, SSM0004_GROUP_PARAMETER_OPTIONS, SSM0004_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useAppSelector } from '../../reducers';
import { areExperimentsLoadingSelector, experimentByTreatmentKeySelector, hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { hasProductsInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { laboratoryClient } from '../laboratoryClient';
import { getIsAcceptanceTest } from '../testUtils';
const treatmentKey = SSM0004_TREATMENT_KEY;
const groupParameterKey = SSM0004_GROUP_PARAMETER_KEY;
const groupParameterOptions = SSM0004_GROUP_PARAMETER_OPTIONS;
export const logSSM0004Exposure = () => {
  laboratoryClient.logExposure(treatmentKey);
};

/**
 * TODO if productized:
 * - Update seats/tb ATs for new price display
 * - Eligibility criteria: seats only
 *    - term selector not shown
 *    - if the sku tied to a suite tile or merch card has >1 term, it should show ACAP price and ACAP subtext, with tooltip showing the ACMP or MCMP price
 * - It will affect .com, add same logic to MobileSuiteTile and MobileHighlightedMerchCard
 * - Move PricingTermsSubtext to HighlightedPriceDisplay ??? not sure since that component is looking quite scary already
 */
export const SSM0004ExperimentSelector = state => {
  const isAcceptanceTest = getIsAcceptanceTest();
  const isUngatedForSeats = isUngatedForSeatsSelector(state);
  const experiment = experimentByTreatmentKeySelector(state, treatmentKey);
  const areExperimentsLoading = areExperimentsLoadingSelector(state);
  const hasExperimentsFetchSucceeded = hasExperimentsFetchSucceededSelector(state);
  const isPaidPortal = hasProductsInProductInventorySelector(state);
  const isEligibleForExperiment = !isAcceptanceTest && hasExperimentsFetchSucceeded && isUngatedForSeats && !isPaidPortal;
  const experimentCohort = experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey];
  const isControl = isEligibleForExperiment && experimentCohort === groupParameterOptions.control;
  const isVariant = isEligibleForExperiment && experimentCohort === groupParameterOptions.variant;
  return {
    isEligibleForSSM0004: isEligibleForExperiment,
    isSSM0004Control: isControl,
    isSSM0004Variant: isVariant,
    isSSM0004Fetched: hasExperimentsFetchSucceeded,
    isSSM0004Loading: areExperimentsLoading
  };
};
export const useSSM0004ExperimentEffect = () => {
  const experiment = useAppSelector(SSM0004ExperimentSelector);
  const {
    isEligibleForSSM0004,
    isSSM0004Fetched
  } = experiment;
  useEffect(() => {
    if (isEligibleForSSM0004 && isSSM0004Fetched) {
      logSSM0004Exposure();
    }
  }, [isEligibleForSSM0004, isSSM0004Fetched]);
  return experiment;
};